// Ant Design theme styles used by the ConfigProvider component
import { lightColors } from "styles/designSystemVars"
import buttonStyles from "styles/theme/buttonStyles"

export const primaryTheme = {
  // tokens cannot be set with CSS variables
  token: {
    /** colors */

    colorPrimary: lightColors.colorBrandBgDefault,
    // colorInfo: "#00719f", // TODO: review when implementing message colors
    colorPrimaryBgHover: lightColors.colorBrandBgHover,
    // "colorPrimaryHover": "#0086b4",
    colorPrimaryActive: lightColors.colorBrandBgPressed,
    colorPrimaryBorder: lightColors.colorBrandBorderDefault,
    colorPrimaryBorderHover: lightColors.colorBrandBgHover,

    colorSuccess: lightColors.colorSuccessBgDefault,
    colorWarning: lightColors.colorWarningBgDefault,
    colorError: lightColors.colorCriticalBgDefault,

    // colorBorder: "#AAADB1",
    /** Select selected option background color */
    controlItemBgActive: "#F6F9FA",
    /** Collapse background */
    colorFillAlter: "white", // "#FBFCFD", // instead of transparent
    /** error colors */
    colorError: lightColors.colorCriticalTextDefault,
    colorErrorBorderHover: lightColors.colorCriticalBorderDefault,
    colorErrorHover: lightColors.colorCriticalBgHover,
    // Tooltip background color
    colorBgSpotlight: "#1A3140",

    /** text colors */
    colorTextBase: lightColors.colorTextPrimaryDefault,
    colorTextTertiary: lightColors.colorTextTertiaryDefault,
    colorTextQuaternary: lightColors.colorTextQuaternaryDefault,
    colorTextDisabled: lightColors.colorDisabledTextDefault,

    /** text colors */
    fontFamily: "var(--prime-font-family)", // Open Sans
    fontSize: 13,

    colorTextPlaceholder: lightColors.colorTextTertiaryDefault,

    /** controlHeight: modifies the controls' "medium" size padding to affect controls' height
     * The "small" and "large" controls are 6px smaller/larger than the "medium" size
     **/
    // controlHeight: 32,

    lineWidth: 1, // Border width of base components
    borderRadius: 7.832,

    /** Collapse arrow icon padding-inline-end */
    marginSM: 5,

    /** Collapse header right and left padding */
    padding: 13.78,
    /** Collapse header top and bottom padding */
    paddingSM: 8,

    // Segmented time to move from one item to another
    motionDurationSlow: "0.1s", // "0.3s",
  },
  components: {
    Typography: {
      titleMarginTop: 0,
      titleMarginBottom: 0,
    },
    Badge: {
      dotSize: 10,
    },
    Button: buttonStyles,
    // Input: {
    //   paddingBlock: 9,
    //   paddingInline: 12,
    // },
    Dropdown: {
      controlItemBgHover: lightColors.colorBrandBgSoftHover,
      controlItemBgActiveHover: lightColors.colorBrandBgSoftPressed,
      controlItemBgActive: lightColors.colorBrandBgSoftPressed,
      colorTextDisabled: lightColors.colorDisabledTextDefault,
      colorTextDescription: lightColors.colorTextTertiaryDefault,
      colorText: lightColors.colorTextPrimaryDefault,
      colorPrimaryBorder: lightColors.colorBrandBorderDefault,
      colorPrimary: lightColors.colorBrandDefault,
      colorError: lightColors.colorCriticalDefault,
      colorBgElevated: lightColors.colorSurfaceRaisedBg,
      paddingBlock: 6,
      paddingXXS: 11,
    },
    Form: {
      itemMarginBottom: 14,
      verticalLabelPadding: "0 0 2px",
    },
    Modal: {
      borderRadiusLG: 10,
    },
    Notification: {
      zIndexPopup: 99999999999999, // maxing this - should always be top layer
    },
    Table: {
      rowHoverBg: lightColors.colorSurfaceBaseDefault,
      rowSelectedHoverBg: lightColors.colorBrandBgSoftHover,
    },
    Tabs: {
      // colorBorderSecondary: lightColors.colorBrandBorderDefault,
      itemActiveColor: "var(--prime-color-text-inverse-default)",
    },
    Tour: {
      // colorPrimary, // does not override token.colorPrimary for "default" type
      fontSize: 13,
      fontWeightStrong: 700, //weight of heading
      colorBgElevated: "#FBFCFD", // default background
    },
    Notification: {
      zIndexPopup: 99999999999999, // maxing this - should always be top layer
    },
    Segmented: {
      itemSelectedBg: lightColors.colorBrandBgDefault,
      itemActiveBg: lightColors.colorBrandBgPressed, // Background color of item when active	string	rgba(0, 0, 0, 0.15)
      // itemColor: rgba(0, 0, 0, 0.65), // Text color of item	string	rgba(0, 0, 0, 0.65)
      itemHoverBg: lightColors.colorBrandBgHover, // Background color of item when hover	string	rgba(0, 0, 0, 0.06)
      itemHoverColor: lightColors.colorTextInverseDefault, //Text color of item when hover	string	rgba(0, 0, 0, 0.88)
      itemSelectedBg: lightColors.colorBrandBgDefault, // Background color of item when selected	string	#ffffff
      itemSelectedColor: lightColors.colorTextInverseDefault, // Text color of item when selected	string	rgba(0, 0, 0, 0.88)
      // trackBg: "#f5f5f5", // Background of Segmented container	string	#f5f5f5
      trackPadding: 2, // Padding of Segmented container	string | number	2
    },
  },
}
